import React, { createContext, forwardRef, useRef, useState } from "react"
import { Form as ReactstrapForm } from "reactstrap"
import { createRequestActivity, waitForRequestActivity, withRequestActivity } from "../services/requestActivity"

export const SubmissionContext = createContext(null)

const createForm = (Component) => forwardRef(function ApiForm(
  { onSubmit, ...props }, ref
) {
  const submitting = useRef(false)
  const activity = useRef(null)
  if (!activity.current) activity.current = createRequestActivity()
  const [submitter, setSubmitter] = useState(null)
  const handleSubmit = async (event) => {
    if (!onSubmit) return
    event.preventDefault()
    if (submitting.current) return
    submitting.current = true
    const button = event.nativeEvent?.submitter || event.currentTarget.querySelector('button[type="submit"], button:not([type])')
    setSubmitter(button?.getAttribute('data-api-button-id') || null)
    try {
      await withRequestActivity(activity.current, () => onSubmit(event))
    } finally {
      // Some legacy submit handlers start requests without returning a promise.
      await waitForRequestActivity(activity.current)
      submitting.current = false
      setSubmitter(null)
    }
  }
  return (
    <SubmissionContext.Provider value={submitter}>
      {React.createElement(Component, { ...props, ref, onSubmit: handleSubmit })}
    </SubmissionContext.Provider>
  )
})

export const NativeApiForm = createForm("form")
export default createForm(ReactstrapForm)
